/* @ngInject */
const go = (

) => {
  const self = {}

  return self
}

export default go



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/services/go.service.js